/**
 * Soft 21-day program: rotates through experiment slugs.
 * No streaks, user can advance when ready.
 */

import { t } from "@/i18n";

export type ProgramDayMeta = {
  day: number;
  slug: string;
  theme: string;
  blurb: string;
};

const DAY_SLUGS = [
  "two-minute-breath",
  "three-gratitudes",
  "water-and-window",
  "call-someone-you-miss",
  "stretch-shoulders",
  "walk-without-phone",
  "one-kind-sentence",
  "thank-someone",
  "two-minute-breath",
  "three-gratitudes",
  "stretch-shoulders",
  "call-someone-you-miss",
  "water-and-window",
  "walk-without-phone",
  "one-kind-sentence",
  "thank-someone",
  "two-minute-breath",
  "three-gratitudes",
  "stretch-shoulders",
  "walk-without-phone",
  "one-kind-sentence",
] as const;

export const PROGRAM_DAY_SLUGS: string[] = [...DAY_SLUGS];

export function programDayMeta(day: number): ProgramDayMeta {
  const clamped = Math.max(1, Math.min(day, DAY_SLUGS.length));
  const idx = clamped - 1;
  const slug = DAY_SLUGS[idx] ?? DAY_SLUGS[0]!;
  const keyDay = clamped;
  return {
    day: Math.max(1, day),
    slug,
    theme: t(`programDays.d${keyDay}.theme`),
    blurb: t(`programDays.d${keyDay}.blurb`),
  };
}

export function slugForProgramDay(day: number): string {
  return programDayMeta(day).slug;
}

export function themeForProgramDay(day: number): string {
  return programDayMeta(day).theme;
}

export function allProgramDays(durationDays = 21): ProgramDayMeta[] {
  const n = Math.min(durationDays, DAY_SLUGS.length);
  return Array.from({ length: n }, (_, i) => programDayMeta(i + 1));
}

export function progressPercent(currentDay: number, durationDays: number): number {
  if (durationDays <= 0) return 0;
  return Math.min(100, Math.round((currentDay / durationDays) * 100));
}
